import React, {ReactNode} from "react";

export enum OverflowHandling {
    Visible = 'visible',
    Auto = 'auto',
}

export function ModalBody({children, overflowHandling}: { children: ReactNode, overflowHandling?: OverflowHandling }) {
    return <div className='modal-body' style={{overflow: overflowHandling ?? OverflowHandling.Visible}}>
        <div className='content'>
            {children}
        </div>
    </div>;
}
